"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const accordionData = [{
  title: "Ograničenje odgovornosti",
  content: "Naša tvrtka ne preuzima odgovornost za bilo kakvu izravnu ili neizravnu štetu nastalu korištenjem naših usluga ili informacija dostupnih na ovoj platformi, osim u slučajevima propisanim zakonom."
}, {
  title: "Sadržaj trećih strana",
  content: "Ne jamčimo za točnost, potpunost ili korisnost sadržaja koji pružaju treće strane. Poveznice na vanjske stranice služe isključivo kao pomoć korisnicima i ne podrazumijevaju našu podršku."
}, {
  title: "Obveze i obeštećenje korisnika",
  content: "Korisnik se obvezuje obeštetiti i zaštititi našu tvrtku od svih zahtjeva, gubitaka ili troškova proizašlih iz kršenja ovih uvjeta ili neovlaštenog korištenja intelektualnog vlasništva."
}];
export default function WhyChooseOmSteel() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="253839" id="odgovornost" className="py-16 md:py-24 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold mb-10 md:mb-16 text-foreground tracking-tight">
            Pravna Odgovornost
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
            {}
            <div className="w-full">
              <Accordion type="single" collapsible defaultValue="item-0" className="w-full flex flex-col gap-3">
                {accordionData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-none">
                    <AccordionTrigger className="bg-muted data-[state=open]:bg-primary data-[state=open]:text-primary-foreground px-5 py-4 rounded-lg hover:no-underline text-base md:text-lg font-default font-semibold transition-colors duration-300 [&[data-state=open]>svg]:text-primary-foreground shadow-sm">
                      {item.title}
                    </AccordionTrigger>
                    <AccordionContent className="bg-card border border-border border-t-0 px-5 py-6 text-muted-foreground leading-relaxed text-sm md:text-base rounded-b-lg shadow-md">
                      {item.content}
                    </AccordionContent>
                  </AccordionItem>)}
              </Accordion>
            </div>

            {}
            <div className={`transition-all duration-700 delay-200 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
              <AspectRatio ratio={16 / 10} className="bg-muted overflow-hidden rounded-lg shadow-xl">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/pravna_odgovornost_dokumentacija.png" alt="Pravna dokumentacija i uvjeti poslovanja" className="object-cover w-full h-full hover:scale-105 transition-transform duration-700" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/pravna_odgovornost_dokumentacija.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/pravna_odgovornost_dokumentacija.png-wvc-sizes" loading="lazy" />
              </AspectRatio>
            </div>
          </div>
        </div>
      </div>
    </section>;
}